import { useCallback, useEffect, useState } from 'react';
import ManpowerEditor from './ManpowerEditor';
import './Manpower.css';

/**
 * "Manage team" for one schedule, in a large modal (schedule list, schedule
 * form, schedule portal). Same editor as the setup wizard's manpower step.
 */
function ManageTeamModal({ auditId, auditName, subtitle, onClose, onSaved }) {
  const [dirty, setDirty] = useState(false);

  const close = useCallback(() => {
    // eslint-disable-next-line no-alert
    if (dirty && !window.confirm('Close without saving the team changes?')) return;
    onClose();
  }, [dirty, onClose]);

  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && close();
    window.addEventListener('keydown', onKey);
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = overflow;
    };
  }, [close]);

  return (
    <div className="mtm" role="dialog" aria-modal="true" aria-labelledby="mtm-title">
      <div className="mtm__backdrop" onClick={close} />
      <div className="mtm__panel">
        <header className="mtm__head">
          <div>
            <h2 id="mtm-title">Manage team{auditName ? ` — ${auditName}` : ''}</h2>
            <p>{subtitle || 'Add people or whole teams, set the lead auditor, and mark who is off or replaced on some days.'}</p>
          </div>
          <button type="button" className="mtm__close" onClick={close} aria-label="Close">
            ×
          </button>
        </header>
        <div className="mtm__body">
          <ManpowerEditor auditId={auditId} layout="modal" onDirtyChange={setDirty} onSaved={onSaved} />
        </div>
      </div>
    </div>
  );
}

export default ManageTeamModal;
